'use client';

import type {
  CampaignPlacement,
  Device,
  ProductType,
  SessionId,
  USAStateAcronym,
  ZipCode,
} from '@hc-frontend/core-types';
import type { FeaturedAds } from '@hc-frontend/core-types';
import { Placement } from '@hc-frontend/core-types';
import { useEventBus, useTrackingContexts } from '@hc-frontend/core-ui';
import type { SendMetricEventTarget } from '@hc-frontend/shells-shared';
import { useEffect } from 'react';

import type { AdImpressionEvent } from '../../atoms/ad-events-subscription';

type TypAdsListTrackImpressionsProps = {
  adsSource?: 'FeaturedAds' | 'AdButler' | 'MediaAlpha';
  ads: FeaturedAds;
  productType: ProductType;
  campaignPlacement: CampaignPlacement;
  sessionId: SessionId;
  device: Device;
  stateAcronym: USAStateAcronym;
  zipCode: ZipCode;
};
export default function TypAdsListTrackImpressions({
  adsSource = 'FeaturedAds',
  ads,
  productType,
  campaignPlacement,
  sessionId,
  device,
  stateAcronym,
  zipCode,
}: TypAdsListTrackImpressionsProps) {
  const eventBus = useEventBus();
  const contexts = useTrackingContexts();

  useEffect(() => {
    eventBus.publish<AdImpressionEvent, SendMetricEventTarget>({
      topic: 'core.ui.ad.impression',
      adsSource,
      featuredAds: ads,
      id: '',
      campaignPlacement,
      placement: Placement.enum.TYP,
      productType,
      source: '',
      contexts,
      device,
      sessionId,
      stateAcronym,
      zipCode,
      domain: window.location.hostname.replace(/(qa|stg|local)\./g, ''),
    });
  }, [
    ads,
    campaignPlacement,
    contexts,
    device,
    eventBus,
    productType,
    sessionId,
    stateAcronym,
    zipCode,
    adsSource,
  ]);

  return null;
}
